<template>
    <div>
        <Header />
        <PageTitle />
        <MeetOurTeam />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../Team/PageTitle'
import MeetOurTeam from '../Team/MeetOurTeam'
import Footer from '../Layout/Footer'

export default {
    name: 'TeamPage',
    components: {
        Header,
        PageTitle,
        MeetOurTeam,
        Footer,
    }
}
</script>
